import React from "react";

import { Snackbar, SnackbarContent } from "@material-ui/core";

export class SnackBar extends React.Component {
    render() {
        const {
            success,
            fail,
            close,
            successMessage,
            failMessage
        } = this.props;

        return (
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                autoHideDuration={4000}
                open={success || fail}
                onClose={() => {
                    close();
                    this.setState({
                        createFolderFail: false,
                        createFolderSuccess: false
                    });
                }}
            >
                <SnackbarContent
                    style={{
                        backgroundColor: success
                            ? "green"
                            : fail
                            ? "red"
                            : "white",
                        color: "white"
                    }}
                    message={success ? successMessage : fail ? failMessage : ""}
                />
            </Snackbar>
        );
    }
}
